import {DocumentDuplicateIcon} from '@heroicons/react/solid';
import {useParams} from 'react-router-dom';

import {Badge, Header, SpinningLoader} from '@/components';
import {copyToClipboard} from '@/utils/user';

import useBusinessSummary from './useBusinessSummary';
import {WebhookDeliveriesDisplay} from './WebhookDeliveriesDisplay';

const MerchantBusinessWebhookDeliveries = () => {
  const {businessId} = useParams();
  const {business, isLoading} = useBusinessSummary(businessId ?? '');

  return (
    <main className="mt-10 mb-5 mx-4 md:mx-10">
      <Header
        dataCy="merchant-business-webhook-deliveries-title"
        title="Business Webhook Deliveries"
      />

      {/* Identifies which business's deliveries this page is showing —
          without it there's no way to tell whose webhooks these are. */}
      <div
        className="mt-3 py-2 px-3 flex items-center gap-3 bg-gray-100 dark:bg-gray-900 rounded-md"
        data-testid="webhooks-business-summary"
      >
        {isLoading ? (
          <SpinningLoader size={5} />
        ) : (
          <>
            <span className="font-semibold text-gray-900 dark:text-gray-100">
              {business?.name ?? 'Unknown business'}
            </span>
            <span className="flex items-center gap-1 text-sm text-gray-500 dark:text-gray-400 truncate">
              {businessId}
              <span
                title="click to copy business ID"
                onClick={() => copyToClipboard(businessId ?? '')}
              >
                <DocumentDuplicateIcon className="w-4 h-4 text-cyan-700 cursor-pointer" />
              </span>
            </span>
            <Badge
              label={
                business?.meta?.flags?.isVerified ? 'Verified' : 'Unverified'
              }
              colorScheme={
                business?.meta?.flags?.isVerified ? 'successful' : 'failed'
              }
            />
          </>
        )}
      </div>

      <WebhookDeliveriesDisplay businessId={businessId ?? ''} />
    </main>
  );
};

export default MerchantBusinessWebhookDeliveries;
